<div class="login-container">
	<div class="login-box">
		<form (submit)="salvarSenha()">
			<img class="logo" *ngIf="AppConfig.theme == 'light'" alt="Talk" src="image/talklogomedium_{{logo}}.png" alt="Logo">
			<mat-form-field>
				<input type="password" 
                       name="SenhaAtual" 
                       ngModel #SenhaAtual
                       [ngModelOptions]="{standalone: true}"
                       matInput 
                       class="form-control input-md" 
                       placeholder="{{ 'telaUsuario.senhaAtual' | translate }}"
					   [(ngModel)]="senha.senhaAtual">
                    <span class="show-pass2">
                        <mat-icon (click)="mostrarSenha(SenhaAtual)" *ngIf="SenhaAtual.type == 'password'">visibility_off</mat-icon>
                        <mat-icon (click)="mostrarSenha(SenhaAtual)" *ngIf="SenhaAtual.type == 'text'">visibility</mat-icon>
                    </span>
            </mat-form-field>
            <mat-form-field>
                <input [(ngModel)]="senha.senha" 
                       class="form-control input-md" 
                       ngModel #SenhaNovat
                       [ngModelOptions]="{standalone: true}"
                       matInput 
                       type="password" 
                       (keypress)='impedirEspaco($event)'
                       (keyup)='validaRegraSenha(filtro)'
                       placeholder="{{ 'telaUsuario.novaSenha' | translate }}" >
                <span class="show-pass">
                    <mat-icon (click)="mostrarSenha(SenhaNovat)" *ngIf="SenhaNovat.type == 'password'">visibility_off</mat-icon>
                    <mat-icon (click)="mostrarSenha(SenhaNovat)" *ngIf="SenhaNovat.type == 'text'">visibility</mat-icon>
                </span>
                <div id="popover-password">
                    <p class="strength-label" *ngIf="filtro.strengthLabelKey" [ngClass]="'strength-' + filtro.strengthClass">
                        {{ filtro.strengthLabelKey | translate }}
                    </p>
                    <div class="progress">
                        <div id="password-strength" 
                            class="progress-bar" 
                            role="progressbar" 
                            [style.width.%]="filtro.strengthPercent"
                            [ngClass]="{
                                'progress-bar-empty': filtro.strengthClass === 'empty',
                                'progress-bar-danger': filtro.strengthClass === 'weak',
                                'progress-bar-warning': filtro.strengthClass === 'medium',
                                'progress-bar-success': filtro.strengthClass === 'strong'
                            }">
                        </div>
                    </div>
                    <ul class="list-unstyled">
                        <li class="">
                            <span class="low-upper-case">
                                <i class="fa" [ngClass]="{'fa-circle': !filtro.lowUpperCase, 'fa-check': filtro.lowUpperCase}" aria-hidden="true"></i>
                                &nbsp;{{ 'telaUsuario.RegraSenha1' | translate }}
                            </span>
                        </li>
                        <li class="">
                            <span class="one-number">
                                <i class="fa" [ngClass]="{'fa-circle': !filtro.number, 'fa-check': filtro.number}" aria-hidden="true"></i>
                                &nbsp;{{ 'telaUsuario.RegraSenha2' | translate }}
                            </span> 
                        </li>
                        <li class="">
                            <span class="one-special-char">
                                <i class="fa" [ngClass]="{'fa-circle': !filtro.specialChar, 'fa-check': filtro.specialChar}" aria-hidden="true"></i>
                                &nbsp;{{ 'telaUsuario.RegraSenha3' | translate }}
                            </span>
                        </li>
                        <li class="">
                            <span class="eight-character">
                                <i class="fa" [ngClass]="{'fa-circle': !filtro.eightChar, 'fa-check': filtro.eightChar}" aria-hidden="true"></i>
                                &nbsp;{{ 'telaUsuario.RegraSenha4' | translate }}
                            </span>
                        </li>
                        <li class="">
                            <span class="not-weak">
                                <i class="fa" [ngClass]="{'fa-circle': filtro.senhaFraca, 'fa-check': !filtro.senhaFraca}" aria-hidden="true"></i>
                                &nbsp;{{ 'telaUsuario.RegraSenha5' | translate }}
                            </span>
                        </li>
                    </ul>
                </div>
            </mat-form-field>
            <mat-form-field>
	
				<input type="password" 
                       ngModel #ConfirmeSenha
                       [ngModelOptions]="{standalone: true}"
                       matInput 
                       (keyup)='validaRegraSenha(filtro)'
                       (keypress)='impedirEspaco($event)'
                       class="form-control input-md" 
                       placeholder="{{ 'telaUsuario.novaSenhaConfirmcao' | translate }}"
					   [(ngModel)]="filtro.confirmacaoSenha">
                    <span class="show-pass2">
                        <mat-icon (click)="mostrarSenha(ConfirmeSenha)" *ngIf="ConfirmeSenha.type == 'password'">visibility_off</mat-icon>
                        <mat-icon (click)="mostrarSenha(ConfirmeSenha)" *ngIf="ConfirmeSenha.type == 'text'">visibility</mat-icon>
                    </span>
                    <mat-hint *ngIf="filtro.senhaDiferente && filtro.confirmacaoSenha.length > 0" class="erro">
                        {{ 'telaUsuario.repetirSenhaErro' | translate }}
                    </mat-hint>
			</mat-form-field>
            <div>
                &nbsp;
            </div>
			<button type="submit" 
                    mat-raised-button 
                    [disabled]="!senhaValida"
                    color="primary">
				    {{ 'telaPadrao.salvar' | translate }}
			</button>
     
		</form>
	</div>
</div>